import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "home",
    component: () => import("../views/HomeView.vue")
  },
  {
    path: "/:category",
    component: () => import("../views/HomeView.vue"),
    // В компоненте HomeView для доступа к props  просто объявляем category в props 
    props: true
  },
  {
    path: "/project/:id",
    name: "project",
    component: () => import("../views/HomeView.vue"),
    // В компоненте HomeView для доступа к props  просто объявляем id в props 
    props: true
  },
  {
    path: "/about",
    name: "about",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ "../views/HomeView.vue")
  },
  {
    path: '/:pathMatch(.*)*',
    name: '404',
    component: () => import("../views/NotFoundView.vue")
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
